const devMode = process.env.NODE_ENV !== "production" || process.env.REACT_APP_STAGING;

export default {
    isDevMode: () => {
        return devMode;
    },
}